'use client'

import { useAction } from 'next-safe-action/hooks'
import { UseFormReturn } from 'react-hook-form'

import { findID, TFindID, TFindIDResponse } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

export const useFindID = ({
  form,
  onSuccess,
}: {
  form: UseFormReturn<TFindID>
  onSuccess: (response: TFindIDResponse) => void
}) => {
  const { handleServerError } = useServerErrorHandler(form)

  const action = useAction(findID, {
    onSuccess: ({ data }) => {
      if (data) {
        onSuccess(data)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  return action
}
